import { departmentDashboard } from '../../actions/constant';

const {
GET_SUPERVISOR_ALERT_REQUEST_SETTING,
  GET_SUPERVISOR_ALERT_SUCCESS_SETTING,
  GET_SUPERVISOR_ALERT_FAILURE_SETTING,
  GET_SUPERVISOR_ALERT_LOADING_SETTING,
  GET_SUPERVISOR_ALERT_RESET_SETTING,
} = departmentDashboard;

const intitialstate: object = {
  response: null,
  isAlert: false,
  errorMessage: '',
  loading: false,
};

export const getSupervisoryAlertSettingReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_SUPERVISOR_ALERT_SUCCESS_SETTING: {
      return {
        ...state,
        isAlert: true,
        response: action.payload.data,
        loading: false,
      };
    }

    case GET_SUPERVISOR_ALERT_FAILURE_SETTING:
      return {
        ...state,
        isAlert: false,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };

    case GET_SUPERVISOR_ALERT_LOADING_SETTING:
      return {
        ...state,
        loading: true,
      };

    case GET_SUPERVISOR_ALERT_RESET_SETTING:
      return intitialstate;

    default:
      return state;
  }
};
